export enum LocalStorageKey {
  User = 'AM_User',
}
